import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import {
  Button,
  Box,
  Tooltip,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Rocket } from 'lucide-mui';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../../reducers';
import { usePlan } from '../../plan/hooks/plan';
import { pushModal } from '../../globalModals/globalModalsSlice';

const iconStyle = { width: 16, height: 16 };

const UpsellButton = ({ selected }: { selected?: 'annual' | 'unlimited' }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const { isPlan } = usePlan();
  if (isPlan(['ENTERPRISE'])) {
    return null;
  }

  const { term } = useSelector((state: RootState) => state.plan.subscription);
  const showGoAnnual =
    selected !== 'unlimited' &&
    (selected === 'annual' ||
      (isPlan(['GROWTH', 'BUSINESS', 'ENTERPRISE']) && term === 'monthly'));

  const showGoUnlimited =
    selected === 'unlimited' || (!showGoAnnual && isPlan(['GROWTH']));

  const handleClick = () => {
    dispatch(pushModal({ type: 'upsell-modal' }));
  };

  if (!showGoAnnual && !showGoUnlimited) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      {showGoAnnual && (
        <Tooltip title={t('upgrade.tooltips.annual')} arrow placement="bottom">
          {isSmallScreen ? (
            <IconButton
              color={selected === 'annual' ? 'primary' : 'default'}
              onClick={handleClick}
              sx={{ width: '40px', height: '40px' }}
            >
              <Rocket sx={iconStyle} />
            </IconButton>
          ) : (
            <Button
              variant={selected === 'annual' ? 'contained' : 'outlined'}
              color={selected === 'annual' ? 'primary' : 'secondary'}
              onClick={handleClick}
              startIcon={<Rocket sx={iconStyle} />}
              sx={{ height: '40px' }}
            >
              {t('upgrade.buttons.saveMoney')}
            </Button>
          )}
        </Tooltip>
      )}
      {showGoUnlimited && (
        <Tooltip
          title={t('upgrade.tooltips.unlimited')}
          arrow
          placement="bottom"
        >
          {isSmallScreen ? (
            <IconButton
              color={selected === 'unlimited' ? 'primary' : 'default'}
              onClick={handleClick}
              sx={{ width: '40px', height: '40px' }}
            >
              <Rocket sx={iconStyle} />
            </IconButton>
          ) : (
            <Button
              variant={selected === 'unlimited' ? 'contained' : 'outlined'}
              color={selected === 'unlimited' ? 'primary' : 'secondary'}
              onClick={handleClick}
              startIcon={<Rocket sx={iconStyle} />}
              sx={{ height: '40px' }}
            >
              {t('upgrade.buttons.goUnlimited')}
            </Button>
          )}
        </Tooltip>
      )}
    </Box>
  );
};

export default UpsellButton;
